import dynamic from 'next/dynamic';

import type { HeroConfigProps } from 'components/Hero/config';
import type { FC } from 'react';

const HeroCalendar = dynamic(() => import('components/Hero/variants/Calendar'));
const HeroCarousel = dynamic(() => import('components/Hero/variants/Carousel'));
const HeroCentered = dynamic(() => import('components/Hero/variants/Centered'));
const HeroCenteredBackground = dynamic(() => import('components/Hero/variants/CenteredBackground'));
const HeroCustom = dynamic(() => import('components/Hero/variants/Custom'));
const HeroDemoVideo = dynamic(() => import('components/Hero/variants/DemoVideo'));
const HeroFeaturedResource = dynamic(() => import('components/Hero/variants/FeaturedResource'));
const HeroForm = dynamic(() => import('components/Hero/variants/Form'));
const HeroLeftAligned = dynamic(() => import('components/Hero/variants/LeftAligned'));
const HeroPricing = dynamic(() => import('components/Hero/variants/Pricing'));
const HeroSplitLottie = dynamic(() => import('components/Hero/variants/SplitLottie'));
const HeroTrustBar = dynamic(() => import('components/Hero/variants/TrustBar'));

interface HeroProps extends HeroConfigProps {
  includeBreadcrumbs?: boolean;
  icon?: string;
  iconV2?: {
    file?: {
      url: string;
    };
    alt?: string;
  };
  breadcrumbTitle?: string;
}

const Hero: FC<HeroProps> = ({ variant, ...props }) => {
  switch (variant) {
    case 'carousel':
      return <HeroCarousel {...props} />;
    case 'centered':
      return <HeroCentered {...props} />;
    case 'centeredBackground':
      return <HeroCenteredBackground {...props} />;
    case 'leftAligned':
      return <HeroLeftAligned {...props} />;
    case 'pricing':
      return <HeroPricing {...props} />;
    case 'splitLottie':
      return <HeroSplitLottie {...props} />;
    case 'trustBar':
      return <HeroTrustBar {...props} />;
    case 'form':
      return <HeroForm {...props} />;
    case 'featuredResource':
      return <HeroFeaturedResource {...props} />;
    case 'custom':
      return <HeroCustom {...props} />;
    case 'demoVideo':
      return <HeroDemoVideo {...props} />;
    case 'calendar':
      return <HeroCalendar {...props} />;
    default:
      throw new Error(`Unknown variant: ${variant}`);
  }
};

export default Hero;
